import {Subtemplate, SubtemplateVersion} from 'notebook/entry-templates/TemplateConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class SubtemplateUpdater extends DocumentEvaluationUpdater<Subtemplate, SubtemplateVersion> {
  getDoc(item: Subtemplate): SubtemplateVersion {
    return item.subtemplateVersion;
  }

  traverse(
    evalTraverser: DocumentTraverser,
    newDoc: SubtemplateVersion,
    oldDoc: SubtemplateVersion | null
  ): void {
    evalTraverser.walkSubtemplateVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: SubtemplateVersion): SubtemplateVersion {
    return mapper.mapSubtemplateVersion(doc, null);
  }

  updatedRoot(root: Subtemplate, doc: SubtemplateVersion): Subtemplate {
    return {...root, subtemplateVersion: doc};
  }
}
